import { AxiosInstance } from 'axios';
import { AvailableProducts, Product } from 'referral-types';
import { simulate } from './utils';
import { ProductType } from '../components/store/constants';
import { Size } from '../constants';
import { SITE_URL } from './service';

export const baseEndpoint = 'product';

export class ProductApi {
  private apiInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getProductById(id: string): Promise<Product> {
    await simulate();

    const response = await this.apiInstance.get(`/${id}`);

    return response.data;
  }

  async getAllProducts(): Promise<AvailableProducts> {
    await simulate();
    const response = await this.apiInstance.get(`/all`);

    return response.data;
  }

  async getProducts(productType: ProductType): Promise<Array<Product>> {
    await simulate();
    const response = await this.apiInstance.get(`/${productType}`);

    return response.data;
  }

  async getBulkProducts(productIds: Array<string>): Promise<Array<Product>> {
    await simulate();
    
    const params = new URLSearchParams();
    
    params.append('productIds', productIds.join(','));
    
    const response = await this.apiInstance.get('/bulk', { params });

    return response.data;
  }
  
  getProductImageSrc(imageId: string, size: Size): string {
    return `${SITE_URL}/image/product/${imageId}?size=${size}`;
  }
}


